import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconPublishComponent } from "./med-icon-publish.component";

@NgModule({
  declarations: [
    MedIconPublishComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconPublishComponent,
  ],
})
export class MedIconPublishModule { }
